import React, { useMemo } from 'react';

import dayjs from 'dayjs';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';

const DealDetails = ({ currentRoute }) => {
  const dispatch = useDispatch();
  const deal = useSelector((state) => state.comRed.currentDeal);

  const { dealId, clientName, targetMarket, minDeskCount, maxDeskCount, MoveInDate } =
    useMemo(() => {
      const dealId = deal?.DealID || 0;
      const clientName = deal?.['Client Name'];
      const targetMarket = deal?.['Target Market'];
      const specialRequirements = deal?.['Location / Special Requirements'];
      const minDeskCount = deal?.['Projected Size'];
      const maxDeskCount = deal?.['Max Projected Size'];
      const MoveInDate = deal?.['Projected Move In Date'];

      return {
        dealId,
        clientName,
        targetMarket,
        specialRequirements,
        minDeskCount,
        maxDeskCount,
        MoveInDate,
      };
    }, [deal]);

  return (
    <>
      <ProviderOptionsContainer>
        <SectionTitle>Client Requirements</SectionTitle>
        <ProviderOptionsTextContainer>
          <Column>
            <Title>Deal ID</Title>
            <SubRightTitle>{dealId}</SubRightTitle>
          </Column>
          <Column>
            <Title>Client</Title>
            <Subtitle>{clientName}</Subtitle>
          </Column>
          <Column>
            <Title>Target Market</Title>
            <Subtitle>{targetMarket}</Subtitle>
          </Column>
          <Column>
            <Title>Min Desks Needed</Title>
            <SubRightTitle>{minDeskCount}</SubRightTitle>
          </Column>
          <Column>
            <Title>Max Desks Needed</Title>
            <SubRightTitle>{maxDeskCount}</SubRightTitle>
          </Column>
          <Column>
            <Title>Move-in Date</Title>
            <Subtitle>{MoveInDate && dayjs(MoveInDate).format('DD-MMM-YYYY')}</Subtitle>
          </Column>
        </ProviderOptionsTextContainer>
      </ProviderOptionsContainer>
    </>
  );
};

const ProviderOptionsContainer = styled.div`
  padding: 5px;
  gap: 15px;
  background: #fff;
  margin: 10px 48px;
`;

const SectionTitle = styled.div`
  font-weight: 500;
  font-size: 16px;
  text-align: left !important;
  margin-bottom: 0.5rem;
  color: #1a1a1a;
`;

const ProviderOptionsTextContainer = styled(ProviderOptionsContainer)`
  gap: 35px;
  justify-content: space-between;
  margin: 10px;
`;

const Column = styled.div`
  display: inline-flex;
  flex-direction: column;
  gap: 10px;
  // min-width: 180px;
  word-break: break-word;
  margin-right: 50px;
`;

const Title = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #1a1a1a;
`;

const RightTitle = styled.div`
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #1a1a1a;
  text-align: right;
`;

const Subtitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #1a1a1a;
`;

const SubRightTitle = styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  color: #1a1a1a;
  text-align: right;
`;

export default React.memo(DealDetails);
